import React, { useState } from "react";
import styles from "./Home.module.css";
import { ReactComponent as WordIcon } from '../word.svg';
import { ReactComponent as Napis } from '../napis.svg';
import { ReactComponent as ExcelIcon } from '../excel.svg';
import { ReactComponent as GmailIcon } from '../gmail.svg';
import { ReactComponent as SheetsIcon } from '../sheets.svg';
import { ReactComponent as PdfIcon } from '../pdf.svg';
import { ReactComponent as DriveIcon } from '../drive.svg';
import { ReactComponent as OpenAiIcon } from '../openai.svg';
import { ReactComponent as AwsIcon } from '../aws.svg';
import { ReactComponent as SchoolIcon } from '../school.svg';
import { ReactComponent as AgreementIcon } from '../agreement.svg';
import { ReactComponent as AutomationIcon } from '../automation.svg';
import { Link } from "react-router-dom";

// Załaduj font Inter z Google Fonts (w index.html lub przez <link> w public/index.html)

export default function Home() {
  const [menuOpen, setMenuOpen] = useState(false);

  // Zamknij menu po kliknięciu linku lub overlay
  const handleMenuClose = () => setMenuOpen(false);

  // Kolory kafelków imitujące różne narzędzia (oryginał: Bubble, Make, Notion, Airtable, Zapier, Pipedrive, n8n, .b)
  const iconTiles = [
    { className: 'icon1', bg: '#fff' },
    { className: 'icon2', bg: '#f3f0ff' },
    { className: 'icon3', bg: '#e0f7fa' },
    { className: 'icon4', bg: '#fff3e0' },
    { className: 'icon5', bg: '#e8f5e9' },
    { className: 'icon6', bg: '#fce4ec' },
    { className: 'icon7', bg: '#e3f2fd' },
    { className: 'icon8', bg: '#fff' },
  ];

  // Placeholdery na różne ikony – podmień na prawdziwe SVG
  const icons = [
    { className: styles.icon1, icon: <WordIcon /> },
    { className: styles.icon2, icon: <WordIcon /> },
    { className: styles.icon3, icon: <WordIcon /> },
    { className: styles.icon4, icon: <WordIcon /> },
    { className: styles.icon5, icon: <WordIcon /> },
    { className: styles.icon6, icon: <WordIcon /> },
    { className: styles.icon7, icon: <WordIcon /> },
    { className: styles.icon8, icon: <WordIcon /> },
  ];

  return (
    <div className={styles.root}>
      {/* HEADER */}
      <header className={styles.header}>
        <Link to="/">
          <img src="/logo2.png" className={styles.logo} />
        </Link>
        <nav className={styles.navBar}>
          <div className={styles.navLinks}>
            {/* <a href="#about" className={styles.navLink}>O nas</a>
            <a href="#services" className={styles.navLink}>Usługi</a>
            <a href="#case-study" className={styles.navLink}>Case Study</a>
            <a href="#webinars" className={styles.navLink}>Webinary</a>
            <a href="#knowledge" className={styles.navLink}>Baza wiedzy</a> */}
          </div>
          <a href="/kontakt" className={styles.ctaBtn}>Bezpłatna konsultacja</a>
          <a href="/login" className={styles.ctaBtn}>Zaloguj</a>
        </nav>
        {/* Hamburger icon for mobile */}
        <button
          className={styles.hamburger}
          aria-label="Otwórz menu"
          onClick={() => setMenuOpen(true)}
        >
          <span />
          <span />
          <span />
        </button>
        {/* Mobile overlay menu */}
        {menuOpen && (
          <div className={styles.menuOverlay} onClick={handleMenuClose}>
            <nav
              className={styles.mobileMenu}
              onClick={e => e.stopPropagation()}
            >
              <button
                className={styles.closeMenu}
                aria-label="Zamknij menu"
                onClick={handleMenuClose}
              >
                &times;
              </button>
              <a href="#about" className={styles.navLink} onClick={handleMenuClose}>O nas</a>
              <a href="#services" className={styles.navLink} onClick={handleMenuClose}>Usługi</a>
              <a href="#case-study" className={styles.navLink} onClick={handleMenuClose}>Case Study</a>
              <a href="#webinars" className={styles.navLink} onClick={handleMenuClose}>Webinary</a>
              <a href="#knowledge" className={styles.navLink} onClick={handleMenuClose}>Baza wiedzy</a>
              <a href="#contact" className={styles.ctaBtn} onClick={handleMenuClose}>Bezpłatna konsultacja</a>
            </nav>
          </div>
        )}
      </header>

      {/* HERO SECTION */}
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <Napis className={styles.heroNapis} />
          <h1 className={styles.heroTitle}>
          Papierowa rewolucja<br />dla Twojego nowoczesnego biura
          </h1>
          <p className={styles.heroDesc}>
            Nie trać czasu i pieniędzy na powtarzalne zadania. Zautomatyzuj je i skaluj swój biznes.
          </p>
          <div className={styles.heroBtns}>
            <a href="/kontakt" className={styles.heroBtnPrimary}>Umów bezpłatną konsultację</a>
            <a href="#services" className={styles.heroBtnSecondary}>Sprawdź nasze usługi</a>
          </div>
          <div className={styles.heroIcons}>
            <div className={styles.icon1}><div className={styles.iconTile}><OpenAiIcon /></div></div>
            <div className={styles.icon2}><div className={styles.iconTile}><WordIcon /></div></div>
            <div className={styles.icon3}><div className={styles.iconTile}><GmailIcon /></div></div>
            <div className={styles.icon4}><div className={styles.iconTile}><SheetsIcon /></div></div>
            <div className={styles.icon5}><div className={styles.iconTile}><PdfIcon /></div></div>
            <div className={styles.icon6}><div className={styles.iconTile}><DriveIcon /></div></div>
            <div className={styles.icon7}><div className={styles.iconTile}><AwsIcon /></div></div>
            <div className={styles.icon8}><div className={styles.iconTile}><ExcelIcon /></div></div>
          </div>
        </div>
      </section>

      {/* SERVICES SECTION */}
      <section className={styles.services} id="services">
        <div className={styles.servicesTitle}>Czym się zajmujemy?</div>
        <div className={styles.servicesHeader}>Automatyzujemy dokumenty, oszczędzamy czas, minimalizujemy ryzyko<br /> i zwiększamy zyski.</div>
        <div className={styles.servicesDesc}>
        W codziennym prowadzeniu firmy łatwo zagubić się w papierologii, powtarzalnych zadaniach i błędach wynikających z pośpiechu. W Paperly rozwiązujemy ten problem dzięki automatyzacji procesów i wykorzystaniu sztucznej inteligencji.<br />
        Specjalizujemy się w tworzeniu inteligentnych systemów, które automatycznie generują, uzupełniają i zarządzają dokumentami na podstawie danych — szybko, precyzyjnie i bez błędów. Dzięki temu Twoja firma może działać efektywniej i z większym zyskiem.
        </div>
              {/* DLA KOGO?
      <section className={styles.services}>
        <div className={styles.servicesTitle}>Dla kogo?</div>
        <div className={styles.servicesDesc}>
          Nasze rozwiązania są idealne dla firm i instytucji, które chcą usprawnić pracę z dokumentami, zminimalizować błędy i zwiększyć efektywność zespołu.
        </div>
        <ul style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          gap: '32px',
          listStyle: 'none',
          padding: 0,
          margin: '0px 0 px 0',
          fontSize: '1.18rem',
          fontWeight: 600,
          color: '#2563eb',
        }}>
          <li>✔️ Dla kancelarii</li>
          <li>✔️ Dla działów HR</li>
          <li>✔️ Dla biur rachunkowych</li>
        </ul>
      </section> */}

        <div className={styles.servicesGrid}>
          {/* Karta 1: Automatyzacja dokumentów biurowych */}
          <div className={styles.serviceCard}>
          <AutomationIcon className={styles.serviceCardIcon} />
            <div className={styles.serviceCardTitle}>Automatyzacje pracy</div>
            <div className={styles.serviceCardDesc}>
              Automatyzujemy generowanie dokumentów. Dzięki temu Twój zespół oszczędza czas, eliminuje błędy i skupia się na ważnych zadaniach. Zyskaj przewagę, ogranicz koszty i przyspiesz pracę biura.
            </div>
            <ul className={styles.serviceCardList}>
              <li><span className={styles.serviceCardListIcon}>✔</span>Automatyczne tworzenie i wysyłka dokumentów</li>
              <li><span className={styles.serviceCardListIcon}>✔</span>Oszczędność czasu i pieniędzy</li>
            </ul>
            <a href="/kontakt" className={styles.serviceCardBtn}>Dowiedz się więcej</a>
          </div>
          {/* Karta 2: Dedykowane aplikacje */}
          <div className={styles.serviceCard}>
          <AgreementIcon className={styles.serviceCardIcon} />
            <div className={styles.serviceCardTitle}>Dedykowane aplikacje</div>
            <div className={styles.serviceCardDesc}>
              Tworzymy aplikacje no-code i low-code, które automatyzują codzienne procesy w Twojej firmie. Proste wdrożenie, intuicyjna obsługa i pełne dopasowanie do Twoich potrzeb.
            </div>
            <ul className={styles.serviceCardList}>
              <li><span className={styles.serviceCardListIcon}>✔</span>Rozwiązania szyte na miarę</li>
              <li><span className={styles.serviceCardListIcon}>✔</span>Łatwa obsługa bez programowania</li>
              <li><span className={styles.serviceCardListIcon}>✔</span>Bezpieczne i skalowalne</li>
            </ul>
            <a href="/kontakt" className={styles.serviceCardBtn}>Dowiedz się więcej</a>
          </div>
          {/* Karta 3: Doradztwo i szkolenia */}
          <div className={styles.serviceCard}>
          <SchoolIcon className={styles.serviceCardIcon} />
            <div className={styles.serviceCardTitle}>Doradztwo i szkolenia</div>
            <div className={styles.serviceCardDesc}>
              Wspieramy firmy w wyborze i wdrożeniu najlepszych narzędzi do automatyzacji. Szkolimy zespoły, doradzamy i pomagamy wdrażać nowoczesne rozwiązania, które usprawniają pracę.
            </div>
            <ul className={styles.serviceCardList}>
              <li><span className={styles.serviceCardListIcon}>✔</span>Indywidualne konsultacje</li>
              <li><span className={styles.serviceCardListIcon}>✔</span>Szkolenia z automatyzacji</li>
              <li><span className={styles.serviceCardListIcon}>✔</span>Wsparcie na każdym etapie</li>
            </ul>
            <a href="/kontakt" className={styles.serviceCardBtn}>Dowiedz się więcej</a>
          </div>
        </div>
      </section>

      {/* TOOLS SECTION
      <section className={styles.tools} id="tools">
        <div className={styles.toolsTitle}>Te narzędzia znamy lepiej, niż własną kieszeń</div>
        <div className={styles.toolsGrid}>
          <div className={styles.toolCard}>
            <img src="/icon-make.svg" alt="Make" className={styles.toolIcon} />
            <div className={styles.toolName}>Make</div>
            <div className={styles.toolDesc}>Automatyzuje powtarzalne zadania, oszczędzając czas i minimalizując błędy. Dzięki temu Twoja firma może skupić się na tym, co naprawdę ważne.</div>
          </div>
          <div className={styles.toolCard}>
            <img src="/icon-n8n.svg" alt="N8N" className={styles.toolIcon} />
            <div className={styles.toolName}>N8N</div>
            <div className={styles.toolDesc}>Open-source do tworzenia własnych automatyzacji dopasowanych do specyficznych potrzeb Twojej firmy.</div>
          </div>
          <div className={styles.toolCard}>
            <img src="/icon-airtable.svg" alt="Airtable" className={styles.toolIcon} />
            <div className={styles.toolName}>Airtable</div>
            <div className={styles.toolDesc}>Połączenie bazy danych i arkusza kalkulacyjnego, które pozwala lepiej zarządzać danymi i projektami.</div>
          </div>
          <div className={styles.toolCard}>
            <img src="/icon-notion.svg" alt="Notion" className={styles.toolIcon} />
            <div className={styles.toolName}>Notion</div>
            <div className={styles.toolDesc}>Pomaga zespołom organizować pracę, dokumentację i projekty w jednym miejscu.</div>
          </div>
          <div className={styles.toolCard}>
            <img src="/icon-pipedrive.svg" alt="Pipedrive" className={styles.toolIcon} />
            <div className={styles.toolName}>Pipedrive</div>
            <div className={styles.toolDesc}>Intuicyjny CRM, który ułatwia zarządzanie sprzedażą i relacjami z klientami.</div>
            </div>
          <div className={styles.toolCard}>
            <img src="/icon-bubble.svg" alt="Bubble" className={styles.toolIcon} />
            <div className={styles.toolName}>Bubble</div>
            <div className={styles.toolDesc}>Pozwala tworzyć zaawansowane aplikacje webowe bez programowania.</div>
          </div>
          </div>
        </section> */}

      {/* CASE STUDY SECTION
      <section className={styles.caseStudy} id="case-study">
        <img src="/case-study-img.svg" alt="Case Study" className={styles.caseStudyImg} />
        <div className={styles.caseStudyContent}>
          <div className={styles.caseStudyTitle}>Case Study</div>
          <div className={styles.caseStudyHeader}>Jak pomogliśmy naszym klientom?</div>
          <div className={styles.caseStudyDesc}>
            Poznaj historie firm, które dzięki automatyzacji i nowoczesnym narzędziom no-code osiągnęły spektakularne efekty. Zobacz, jak wdrożenia Nocodework zmieniły ich codzienną pracę.
          </div>
          <a href="#" className={styles.caseStudyBtn}>Zobacz case study</a>
            </div>
      </section> */}

      {/* TESTIMONIALS SECTION
      <section className={styles.testimonials} id="testimonials">
        <div className={styles.testimonialsTitle}>Opinie klientów</div>
        <div className={styles.testimonialsHeader}>Co mówią o nas klienci?</div>
        <div className={styles.testimonialsGrid}>
          <div className={styles.testimonialCard}>
            <img src="/avatar1.svg" alt="Klient 1" className={styles.testimonialAvatar} />
            <div className={styles.testimonialQuote}>"Dzięki Nocodework nasza firma oszczędza dziesiątki godzin miesięcznie. Automatyzacje działają bezbłędnie!"</div>
            <div className={styles.testimonialName}>Anna Nowak</div>
            <div className={styles.testimonialCompany}>CEO, FirmaX</div>
            </div>
          <div className={styles.testimonialCard}>
            <img src="/avatar2.svg" alt="Klient 2" className={styles.testimonialAvatar} />
            <div className={styles.testimonialQuote}>"Zespół Nocodework świetnie doradził i wdrożył rozwiązania, które naprawdę działają. Polecam!"</div>
            <div className={styles.testimonialName}>Michał Kowalski</div>
            <div className={styles.testimonialCompany}>Marketing Manager, MarketPro</div>
          </div>
          <div className={styles.testimonialCard}>
            <img src="/avatar3.svg" alt="Klient 3" className={styles.testimonialAvatar} />
            <div className={styles.testimonialQuote}>"Szkolenia i wsparcie na najwyższym poziomie. Teraz nasz zespół sam automatyzuje procesy!"</div>
            <div className={styles.testimonialName}>Katarzyna Zielińska</div>
            <div className={styles.testimonialCompany}>COO, StartIT</div>
            </div>
          </div>
        </section> */}

      {/* BLOG SECTION
      <section className={styles.blog} id="blog">
        <div className={styles.blogTitle}>Blog</div>
        <div className={styles.blogHeader}>Wiedza, inspiracje i nowości</div>
        <div className={styles.blogGrid}>
          <div className={styles.blogCard}>
            <img src="/blog1.svg" alt="Blog 1" className={styles.blogImg} />
            <div className={styles.blogCardTitle}>5 automatyzacji, które musisz znać w 2024</div>
            <div className={styles.blogCardDesc}>Poznaj najważniejsze automatyzacje, które pozwolą Ci zaoszczędzić czas i pieniądze w Twojej firmie.</div>
            <a href="#" className={styles.blogCardBtn}>Czytaj więcej</a>
          </div>
          <div className={styles.blogCard}>
            <img src="/blog2.svg" alt="Blog 2" className={styles.blogImg} />
            <div className={styles.blogCardTitle}>No-code vs. low-code – co wybrać?</div>
            <div className={styles.blogCardDesc}>Dowiedz się, czym różnią się platformy no-code i low-code oraz która będzie lepsza dla Twojego biznesu.</div>
            <a href="#" className={styles.blogCardBtn}>Czytaj więcej</a>
          </div>
          <div className={styles.blogCard}>
            <img src="/blog3.svg" alt="Blog 3" className={styles.blogImg} />
            <div className={styles.blogCardTitle}>Jak wdrożyć automatyzację w firmie?</div>
            <div className={styles.blogCardDesc}>Praktyczny przewodnik krok po kroku, jak skutecznie wdrożyć automatyzację procesów biznesowych.</div>
            <a href="#" className={styles.blogCardBtn}>Czytaj więcej</a>
          </div>
        </div>
        </section> */}

      {/* FAQ SECTION */}
      {/* <section className={styles.faq} id="faq">
        <div className={styles.faqTitle}>FAQ</div>
        <div className={styles.faqHeader}>Najczęściej zadawane pytania</div>
        <div className={styles.faqList}>
          <div className={styles.faqItem}>
            <div className={styles.faqQuestion}>Czy wdrożenie automatyzacji jest trudne?</div>
            <div className={styles.faqAnswer}>Nie! Nasz zespół przeprowadzi Cię przez cały proces krok po kroku, a większość wdrożeń realizujemy w kilka dni.</div>
          </div>
          <div className={styles.faqItem}>
            <div className={styles.faqQuestion}>Czy muszę znać się na programowaniu?</div>
            <div className={styles.faqAnswer}>Nie, korzystamy z narzędzi no-code i low-code, które są intuicyjne nawet dla osób nietechnicznych.</div>
          </div>
          <div className={styles.faqItem}>
            <div className={styles.faqQuestion}>Ile kosztuje wdrożenie?</div>
            <div className={styles.faqAnswer}>Każdy projekt wyceniamy indywidualnie, ale już od kilkuset złotych możesz zautomatyzować kluczowe procesy w firmie.</div>
          </div>
        </div>
        </section> */}

      {/* FOOTER SECTION */}
      <footer className={styles.footer}>
        {/* <div className={styles.footerGrid}>
          <div className={styles.footerCol}>
            <div className={styles.footerTitle}>Nawigacja</div>
            <a href="#about" className={styles.footerLink}>O nas</a>
            <a href="#services" className={styles.footerLink}>Usługi</a>
            <a href="#case-study" className={styles.footerLink}>Case Study</a>
            <a href="#webinars" className={styles.footerLink}>Webinary</a>
            <a href="#knowledge" className={styles.footerLink}>Baza wiedzy</a>
          </div>
          <div className={styles.footerCol}>
            <div className={styles.footerTitle}>Dla klientów</div>
            <a href="#contact" className={styles.footerLink}>Bezpłatna konsultacja</a>
            <a href="#blog" className={styles.footerLink}>Blog</a>
            <a href="#faq" className={styles.footerLink}>FAQ</a>
          </div>
          <div className={styles.footerCol}>
            <div className={styles.footerTitle}>Kontakt</div>
            <a href="mailto:kontakt@paperly.io" className={styles.footerLink}>kontakt@paperly.io</a>
            <span className={styles.footerLink}>ul. Przykładowa 1, Warszawa</span>
            <span className={styles.footerLink}>NIP: 123-456-78-90</span>
          </div>
        </div> */}
        <div className={styles.footerBottom}>
          &copy; {new Date().getFullYear()} Paperly. Wszelkie prawa zastrzeżone. Made with ❤️ in Poland
        </div>
      </footer>

      {/* Dalsze sekcje będą dodawane w kolejnych krokach */}
    </div>
  );
}